/**
 * ⟦C62 · lot atelier · friction 7⟧ **Les mots de l'exigence.**
 *
 * « E0 », « E3 » : un code interne (SPEC-UI §4.1, E0 mode doux … E5 plafond). Le joueur lit le MOT
 * (« mode doux », « le public attend ») ; le code et son chiffre vivent derrière « Les dessous » des écrans
 * de consigne. Pur : aucun DOM. Vivait dans `PiedAtelier.tsx` (qui l'importe désormais d'ici) : les cinq
 * mini-jeux en ont besoin pour leurs dessous, et un jeu n'importe pas un écran.
 */

/** Ce que chaque niveau d'exigence raconte (SPEC-UI §4.1 : E0 mode doux … E5 tempo max). */
export const LIBELLE_EXIGENCE: Record<number, string> = {
  0: "mode doux",
  1: "premiers pas",
  2: "ça se tend",
  3: "le public attend",
  4: "le tempo monte",
  5: "tempo max",
};

/** Le mot d'un niveau (« le public attend »), ou rien si le niveau est hors table. */
export function motExigence(k: number): string | null {
  return LIBELLE_EXIGENCE[k] ?? null;
}

/** La ligne des dessous : « Exigence E3, le public attend ». Le code reste lisible, mais derrière le bouton. */
export function ligneExigence(k: number): string {
  const mot = motExigence(k);
  return mot ? `Exigence E${k}, ${mot}` : `Exigence E${k}`;
}
